import React, { useState, useEffect } from 'react'
import ModalResiduo from '../modals/residuo'
import api from '../components/api'
import { dataTableRender, cor, corEnviado, rotulo, rotuloEnviado } from '../components/functions'


const TabelaGestao = (props) => {


    var adesao_institucional_id = props.adesao_institucional_id


    var [resultadoResiduos, setResultadoResiduos] = useState()
    var [ano, setAno] = useState()
    var [residuo_id, setResiduo_id] = useState()




    
    useEffect(() => {

        residuosSS()

    }, [])



    async function residuosSS() {

        if (adesao_institucional_id) {

                await api.get(`residuosTabelaGestao/${adesao_institucional_id}`).then((result) => {

                    //console.log(result.data)

                    setResultadoResiduos(result.data.map((rs) => 
                    
                        <tr style={{ cursor: 'pointer' }} data-toggle="modal" data-target="#modalResiduos" onClick={() => { setAno(rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio); setResiduo_id(rs.residuo_id)}} >

                            <td><center>{rs.anoPerfil ? rs.anoPerfil : rs.anoDesafio}</center></td>
                            <td style={{ backgroundColor: cor(rs.situacaoPerfilAnual)}}><center>{rotulo(rs.situacaoPerfilAnual)}</center></td>
                            <td style={{ backgroundColor: cor(rs.secaoGestao)}} ><center>{rotulo(rs.secaoGestao)}</center></td>
                            <td style={{ backgroundColor: cor(rs.secaoGeracao)}}><center>{rotulo(rs.secaoGeracao)}</center></td>
                            <td style={{ backgroundColor: corEnviado(rs.situacaoEnviado)}}><center>{rotuloEnviado(rs.situacaoEnviado)}</center></td>
                            <td ><center>{rs.dataEnvio}</center></td>

                        </tr>
                    
                    ))


                dataTableRender('dataTableExampleResiduosSS')

                

            }).catch((err) => {
                console.log(err.response)
            })

        }

    }




    return (

        <div>


            <div className="table-responsive">
                <table id="dataTableExampleResiduosSS" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th tyle={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Ano
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Form. Perfil Anual
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Dados de gestão
                                </center>

                            </th>
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Dados de geração de resíduos
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Situação
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Enviado em
                                </center>

                            </th>
                            
                            
                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultadoResiduos}
                    </tbody>
                    
                </table>
            
            </div>


            <ModalResiduo adesao_institucional_id={adesao_institucional_id} ano={ano} residuo_id={residuo_id} residuosSS={residuosSS} />



        </div>

    )

}


export default TabelaGestao


